<template>
  <div>
    <cube-popup
      ref="myPopup"
      :visible.sync="TipDialogVisible"
      type="my-popup"
      class="bind-dialog"
      position="center"
    >
      <div class="bind-dialog-box">
        <h2>{{ $t('message["430"]') }} ？</h2>
        <div class="d-tip-con">
          <div>
            {{ accountTipt[0] }}{{ value }} }{{ accountTipt[1] }}
            <template v-if="baseinfo.bind_dingding === 1">
              {{ $t('message["238"]') }}
            </template><template v-if="baseinfo.bind_qiwei === 1">
              {{ $t('message["720"]') }}
            </template>
            {{ $t('message["592"]') }}
          </div>
          <div>{{ $t('message["952"]') }}.</div>
        </div>

        <div class="bind-d-btn">
          <cube-button
            type="submit"
            :primary="true"
            @click="triggerMerge"
          >
            {{ $t('message["596"]') }}
          </cube-button>
        </div>
        <p>
          <a
            href="javascript:;"
            @click="bindDialogHide"
          >{{ $t('message["64"]') }}</a>
        </p>
      </div>
    </cube-popup>
    <merge-form ref="mergeForm" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import MergeForm from './MergeForm'
export default {
  components: {
    MergeForm
  },
  props: {
    bindType: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
    // userid: {
    //   type: Number,
    //   default: 0
    // }
  },
  data () {
    return {
      TipDialogVisible: this.visible,
      submiting: false,
      typeError: 0
    }
  },
  computed: {
    baseinfo () {
      return this.$store.state.baseinfo
    },
    accountTipt () {
      return this.$t('message["180"]').split('|')
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('merge', ['ajaxNoNotice']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    triggerMerge (val) {
      this.TipDialogVisible = false
      this.$refs.mergeForm.changeLimitDialog(true)
    },
    showPopup (refId) {
      const component = this.$refs[refId]
      component.show()
    },
    async bindDialogHide () {
      let res = await this.ajaxNoNotice()
      res.onSuccess(res => {
        this.TipDialogVisible = false
        // const toast = this.$createToast({
        //   time: 2000,
        //   txt: '操作成功',
        //   type: 'txt'
        // })
        // toast.show()
        this.$selefToast({ text: this.$t('message["81"]') + '！' })
      })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.bind-dialog-box {
  background: #fff;
  border-radius: 4px;
  padding: 15px;
  margin: 15px;
  h2 {
    font-size: 18px;
    padding: 6px 0 16px;
    text-align: center;
  }
  .d-tip-con {
    line-height: 24px;
    font-size: 14px;
    text-align: center;
    margin-bottom: 24px;
  }
  p {
    font-size: 14px;
    text-align: center;
    padding: 20px 0;
  }
}
</style>
